import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=628b3cfb&"
import script from "./Warehouses.vue?vue&type=script&lang=js&"
export * from "./Warehouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Warehouses.vue"
export default component.exports